// "Tapping the heart while signed out."
//
// The sign-in dialog with the item on top: its photo and "Save {{title}} to
// your list", then "Save it for later". Opening it leaves a pending-save note
// (post-sign-in.ts); SavedProvider saves the item as soon as the session
// arrives, whether the guest used the emailed code here or went to Google or
// Apple and came back. Closing it without signing in drops the note.
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { PW } from "@majourneys/booking";
import { SignInModal } from "./sign-in-modal";
import { clearPendingSave, setPendingSave, type PendingSave } from "../lib/post-sign-in";

export function SaveSignInModal({ item, onClose }: { item: PendingSave | null; onClose: () => void }) {
  const { t } = useTranslation();

  useEffect(() => {
    if (item) setPendingSave(item);
  }, [item]);

  if (!item) return null;

  return (
    <SignInModal
      open
      onClose={onClose}
      onDismiss={clearPendingSave}
      heading={t("auth.save_prompt.title")}
      subheading={t("auth.save_prompt.sub")}
      lead={
        <div className="mb-4 flex items-center gap-3 rounded-[14px] p-2.5 pe-12" style={{ background: PW.softTint }}>
          {item.image ? (
            <img src={item.image} alt="" className="h-11 w-11 shrink-0 rounded-[10px] object-cover" />
          ) : null}
          <span className="min-w-0 text-[14px] font-semibold" style={{ color: PW.navy }}>
            {t("auth.save_prompt.item", { title: item.title })}
          </span>
        </div>
      }
    />
  );
}
